export default {"src":"/_next/static/media/lock.5312ed8c.svg","height":28,"width":28};